import { useMutation } from '@apollo/client';
import {
  Box,
  Button,
  ButtonAppearance,
  ButtonSize,
  FormControl,
  Icon,
  IconSize,
  Spinner,
  Text,
  TextArea,
  theme,
  ToastAction,
  ToastType,
  useToastsDispatch,
} from '@bechtel/gds';
import { CREATE_PROJECT_CONFIGURATION, useAppUser } from '@bechtel/ht-clients-common';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ActionContent } from '~/components';
import { PrimaryButtonStyled, SecondaryButtonStyled } from '~/styles';
import { CreateNewConfigurationHeaderStyled, FooterStyled } from './styled';
export interface NewConfigurationProps {
  onClose: () => void;
}
const NewConfiguration: FC<NewConfigurationProps> = ({ onClose }) => {
  const { appUser } = useAppUser();
  const { t } = useTranslation();
  const [configurationValue, setConfigurationValue] = useState('');
  const [error, setConfigurationError] = useState('');

  const [configurationName, setConfigurationName] = useState('');
  const dispatchToast = useToastsDispatch();
  const [InsertProjectConfiguration, { loading: loadingProjectConfiguration }] = useMutation(
    CREATE_PROJECT_CONFIGURATION,
    {
      refetchQueries: ['SearchProjectConfigurations'],
    }
  );

  const createProjectConfiguration = async () => {
    try {
      JSON.parse(configurationValue);
    } catch (error) {
      setConfigurationError('Invalid json object value. Please correct and retry!');
      return;
    }
    if (/\s/.test(configurationName)) {
      setConfigurationError('Invalid configuration Name. Please correct and retry!');
      return;
    }
    await InsertProjectConfiguration({
      variables: {
        createProjectConfigurationInput: {
          //configurationValue: JSON.parse(configurationValue),
          configurationValue: btoa(configurationValue), // encode to base64
          configurationName: configurationName,
          createdBy: appUser?.bun,
          createdDate: new Date(),
          updatedDate: new Date(),
        },
      },
      onCompleted: (data) => {
        setConfigurationError('');
        const configurationSuccessToast: ToastAction = {
          type: 'ADD_TOAST',
          payload: {
            toastType: ToastType.INFO,
            content: 'Configuration added successfully!',
            autoDismissTimeout: 5000,
          },
        };
        dispatchToast(configurationSuccessToast);
        onClose();
      },
      onError: (error) => {
        const configurationErrorToast: ToastAction = {
          type: 'ADD_TOAST',
          payload: {
            toastType: ToastType.INFO,
            content: 'Error while  inserting the configuration.Please try again',
            autoDismissTimeout: 5000,
          },
        };
        dispatchToast(configurationErrorToast);
      },
    });
  };
  return (
    <Box flexDirection={{ sm: 'column' }}>
      <CreateNewConfigurationHeaderStyled>
        <Text color="white" weight="600">
          New Project Configuration
        </Text>
        <Box p={{ sm: '400' }}>
          <Button
            size={ButtonSize.SMALL}
            appearance={ButtonAppearance.TERTIARY}
            style={{ backgroundColor: `${theme.colors.primary[700]}` }}
            onClick={() => onClose()}
          >
            <Icon fillColor="white" icon="close" size={IconSize.MEDIUM} />
          </Button>
        </Box>
      </CreateNewConfigurationHeaderStyled>
      <Box gap={{ sm: '500' }} p={{ sm: '500' }} style={{ width: '100%' }} flexDirection={{ sm: 'column' }}>
        <Box flexDirection={{ sm: 'column' }} gap={{ sm: '500' }} style={{ width: '100%' }}>
          <Box>
            <FormControl style={{ width: '100%' }} label="Configuration Name">
              <TextArea
                rows="1"
                value={configurationName}
                onChange={(event) => {
                  setConfigurationError('');
                  setConfigurationName(event.target.value);
                }}
              ></TextArea>
            </FormControl>
          </Box>
          <Box>
            <FormControl style={{ width: '100%' }} label="Configuration Value">
              <TextArea
                rows="5"
                value={configurationValue}
                onChange={(event) => {
                  setConfigurationError('');
                  setConfigurationValue(event.target.value);
                }}
              ></TextArea>
            </FormControl>
          </Box>
        </Box>
        {error && (
          <Text color="red.500" size="300">
            {error}
          </Text>
        )}
      </Box>
      <FooterStyled>
        <PrimaryButtonStyled
          onClick={() => {
            createProjectConfiguration();
          }}
          disabled={configurationValue.length <= 0 || configurationName.length <= 0 || error.length > 0}
        >
          <ActionContent icon="save" iconStyle="solid" label="Save" />
          {loadingProjectConfiguration && <Spinner />}
        </PrimaryButtonStyled>
        <SecondaryButtonStyled onClick={() => onClose()}>
          <ActionContent icon="close" iconStyle="solid" label="Close" />
        </SecondaryButtonStyled>
      </FooterStyled>
    </Box>
  );
};

export default NewConfiguration;
